import { useAuthAdmin } from "stores/hooks/auth";
import BaseForm from "./base-form";

const BaseTab = () => {
  const admin = useAuthAdmin();

  if (!admin) {
    return null;
  }

  return <BaseForm admin={admin} />;
};

export default BaseTab;
